import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import Card, { CardBody } from '../../components/Card';

const FAQ = ({ faq }) => {
  const [showAnswer, setShowAnswer] = useState(false);

  const toggleAnswer = () => {
    setShowAnswer(prev => !prev);
  };

  return (
    <Card 
      className={`faq ${showAnswer ? 'faq--expanded' : ''}`}
      variant="faq"
      interactive={true}
      onClick={toggleAnswer}
      role="button"
      tabIndex={0}
      aria-expanded={showAnswer}
      aria-controls={`faq-answer-${faq.id}`}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleAnswer();
        }
      }}
    >
      <CardBody className="faq__content">
        <div className="faq__header">
          <h3 className="faq__question">
            {faq.question}
          </h3>
          
          <button 
            className="faq__toggle"
            aria-label={showAnswer ? 'Collapse answer' : 'Expand answer'}
            tabIndex={-1}
          >
            <FontAwesomeIcon 
              icon={showAnswer ? faMinus : faPlus}
              className="faq__icon"
            />
          </button>
        </div>
        
        <div 
          className={`faq__answer-wrapper ${showAnswer ? 'faq__answer-wrapper--expanded' : ''}`}
          id={`faq-answer-${faq.id}`}
        >
          <p className="faq__answer">
            {faq.answer}
          </p>
        </div>
      </CardBody>
    </Card>
  );
};

export default FAQ;
